import StrategyCallButton from './StrategyCallButton'

const defaultContent = {
    title: "Let's talk through what you actually need.",
    description:
        "Whether you need the full program or just one service, the first conversation is the same: your goals, your audience, your budget, and what's worked or hasn't. We'll tell you where to start.",
    cta: {
        label: 'Book a Strategy Call',
        href: '/contact-us',
    },
}

export default function ServicesClosingCta(props) {
    const title = props?.title || defaultContent.title
    const description = props?.description || defaultContent.description
    const cta = props?.cta || defaultContent.cta

    return (
        <section className="bg-[#3f454f]">
            <div className="container mx-auto">
                <div className="mx-auto max-w-3xl text-center px-8 py-20 lg:py-20">
                    <h2 className="text-3xl font-[700] tracking-tight text-white md:text-[44px] md:leading-[1.1]">
                        {title}
                    </h2>

                    <p className="mx-auto mt-4 max-w-xl text-lg leading-7 text-white/60">
                        {description}
                    </p>

                    {cta?.label ? (
                        <div className="mt-8 flex justify-center">
                            <StrategyCallButton className="inline-flex w-fit rounded-full bg-rtl-gradient px-8 py-4 text-base font-semibold text-white shadow-lg transition hover:opacity-95">
                                {cta.label}
                            </StrategyCallButton>
                        </div>
                    ) : null}
                </div>
            </div>
        </section>
    )
}
